import classes from '../DashboardItem.module.css'
import { useSelector, useDispatch } from 'react-redux'
import ThisWeekBox from './ThisWeekBox'
import PendingTaksBox from './PendingTaksBox'
import UpcomingTasksBox from './UpcomingTasksBox'
import { getTasksSummary } from '../../../../lib/fetchApi'
import { useEffect, useState } from 'react'
import { notificationActions } from '../../../../store/notifications'
import TasksGraphBoxWrapper from './TasksGraphBoxWrapper'


export default function TasksSummaryWidget() {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const [summary, setSummary] = useState(null)
    useEffect(() => {     
        let isMounted = true;

        const fetchData = async (noLoading) => {
            if (!isMounted) return;
            if (userToken) {
                const summary = await getTasksSummary(userToken)        
                if (summary && summary.errorMessage) {
                    dispatch(notificationActions.setError(summary))
                } else {
                    setSummary(summary)            
                }
                
            }
        }
        fetchData()
        
        return () => {
            isMounted = false;
        };
    }, []);
    
    return <div className={`${classes.item_inner}`}>
        {summary && <>
            <div className={classes.item_body_grid}>
                <PendingTaksBox summary={summary} />
                <ThisWeekBox summary={summary}/>
                <UpcomingTasksBox summary={summary}/>
                <TasksGraphBoxWrapper summary={summary}/>
            </div>
        </>}
    </div>
}
